import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteBillPaymentRequestForm.NetSuiteBillPaymentFieldsSection',
    {
        vendorDetailsSectionName: 'Vendor Details',
        billPaymentDetailsSectionName: 'Bill Payment Details',
        memoSectionName: 'Memo',
        textFieldPlaceholder: 'Enter value',
        dateFieldPlaceholder: 'Select date',
        payeeFieldText: 'Payee',
        payeeFieldPlaceholder: 'Select payee',
        payeeAddressFieldText: 'Payee Address',
        payeeAddressPlaceholder: 'Select address',
        transactionNumberFieldText: 'Transaction number',
        checkNumberFieldText: 'Check number',
        transactionDateFieldText: 'Date',
        accountFieldText: 'Account',
        payablesAccountFieldText: 'A/P account',
        accountFieldPlaceholder: 'Select account',
        departmentFieldText: 'Department',
        departmentFieldPlaceholder: 'Select department',
        classFieldText: 'Class',
        classFieldPlaceholder: 'Select class',
        locationFieldText: 'Location',
        locationFieldPlaceholder: 'Select location',
        postingPeriodFieldText: 'Posting period',
        toBePrintedFieldText: 'To be printed',
        toBePrintedCheckboxLabel: 'Yes',
        printVoucherFieldText: 'Print voucher',
        printVoucherCheckboxLabel: 'Yes',
    }
);
